import axios from "axios";
import { OrderLineType } from "./types";

export const ORDERLINES_URL = `${process.env.REACT_APP_API_URL}/orders/line`;

// CREATE

export function CreateOrderline(orderline: OrderLineType) {
  return axios.post(`${ORDERLINES_URL}`, orderline);
}

// FetchAll
export function GetOrderlines(orderId: string) {
  return axios.get(`${ORDERLINES_URL}s/${orderId}`);
}

// Delete Record
export function DeleteOrderline(lineId: string) {
  return axios.delete(`${ORDERLINES_URL}/delete`, {
    params: {
      id: lineId,
    },
  });
}
